import * as React from "react";

import { useAccount } from "@azure/msal-react";

import UnauthorizedPage from "../pages/UnauthorizedPage";

import { hasRole } from "../common/authorization";

type PropsType = React.PropsWithChildren & {
  hideInsteadOfUnauthorized?: boolean;
};

export default function RequireSysAdmin(props: PropsType) {
  const account = useAccount();

  // if there is no user data at all, then the user is clearly not going to be
  // authorized to view this page
  if (!account) {
    console.warn("no account found while trying to authorize sysadmin");
    return props.hideInsteadOfUnauthorized ? null : <UnauthorizedPage />;
  }

  // if the user is signed in and also has the sys admin role then we can go
  // ahead and render the children
  if (hasRole(account, "SysAdmin") == true) {
    return <>{props.children}</>;
  }

  console.warn("account found but sysadmin role not granted");

  // For navigation items, return null to hide them. For page access, show UnauthorizedPage
  return props.hideInsteadOfUnauthorized ? null : <UnauthorizedPage />;
}

